import type { PedalCue } from "../music/types.js";

export interface PedalCueStats {
  expected: number;
  hits: number;
  misses: number;
  remaining: number;
}

/**
 * Grades CC64 changes in score order. Timing is intentionally tolerant:
 * many browsers expose MIDI timestamps in a different clock from AudioContext.
 * Pitch practice never blocks when no hardware pedal is connected.
 */
export class PedalCueGrader {
  private cues: PedalCue[] = [];
  private index = 0;
  private hits = 0;
  private misses = 0;

  load(cues: PedalCue[] | undefined): void {
    this.cues = [...(cues ?? [])].sort((a, b) => a.beat - b.beat);
    this.index = 0;
    this.hits = 0;
    this.misses = 0;
  }

  clear(): void {
    this.cues = [];
    this.index = 0;
    this.hits = 0;
    this.misses = 0;
  }

  handle(down: boolean): boolean | null {
    if (this.index >= this.cues.length) return null;
    const expected = this.cues[this.index];
    const ok = expected.down === down;
    if (ok) {
      this.hits += 1;
      this.index += 1;
    } else {
      this.misses += 1;
    }
    return ok;
  }

  getStats(): PedalCueStats {
    return {
      expected: this.cues.length,
      hits: this.hits,
      misses: this.misses,
      remaining: Math.max(0, this.cues.length - this.index),
    };
  }
}
